var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardTemplate',[_c('DepartmentNav',{attrs:{"nav":{
        dashboard:true,
        smartReport:false,
      }}}),_c('AdminAndStaffDashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }